import { defineMessages } from '@dragonraider5/react-intl'

export const FILE_SIZE = '@validations/FILE_SIZE'
export const FILE_TYPE = '@validations/FILE_TYPE'
export const CSV_CODE = '@validations/HACIENDA_CSV_CODE'

export default defineMessages({
  [FILE_SIZE]: {
    id: 'containers.Applications.Steps.Documents.validations.FILE_SIZE',
    description: 'Validation message when file size is to large',
    defaultMessage: 'Lo sentimos, el tamaño del fichero supera los 50mb permitidos.'
  },
  [FILE_TYPE]: {
    id: 'containers.Applications.Steps.Documents.validations.FILE_TYPE',
    description: 'Validation message when file type is no allowed',
    defaultMessage: 'Por favor selecciona un fichero en uno de los siguientes formatos: pdf, word o excel.'
  },
  [CSV_CODE]: {
    id: 'containers.Applications.Steps.Documents.validations.CSV_CODE',
    description: 'Validation message when hacienda csv code is invalid',
    defaultMessage:
      `Por favor asegurate de que introduces los 16 caracteres alfanúmericos del
       Código Seguro de Verificación de su declaración.`
  },
  requiredDocument: {
    id: 'containers.Applications.Steps.Documents.validations.requiredDocument',
    description: 'Validation message when try to pass status and the document is missing',
    defaultMessage:
      `Este documento es obligatorio para poder iniciar el estudio de tu solicitud.`
  }
})
